import NorthEastRoundedIcon from "@mui/icons-material/NorthEastRounded";
import SouthEastRoundedIcon from "@mui/icons-material/SouthEastRounded";
import { type FC } from "react";

import * as Styled from "./TrendIndicator.styles";

interface ITrendIndicatorProps {
  isPositive: boolean;
  label: string;
}

export const TrendIndicator: FC<ITrendIndicatorProps> = ({
  isPositive,
  label,
}) => {
  return (
    <Styled.Root $isPositive={isPositive}>
      {isPositive ? <NorthEastRoundedIcon /> : <SouthEastRoundedIcon />}
      {label}
    </Styled.Root>
  );
};
